import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import ConfigurePage from "./pages/ConfigurePage";
import NotFoundPage from "./pages/NotFoundPage";
import "./App.css";
import { loadServerData } from "./utils/serverData";
import { VIEWMODEL_QUERY_KEY } from "./hooks/useViewModel";

function App() {
	const queryClient = useQueryClient();

	const serverData = useMemo(() => {
		const data = loadServerData();
		// Hydrate query cache synchronously to avoid price flicker
		if (data) {
			queryClient.setQueryData([VIEWMODEL_QUERY_KEY], data);
		}
		return data;
	}, [queryClient]);

	if (!serverData) {
		return <div>Error loading data</div>;
	}

	if (serverData.notFoundMessage) {
		return <NotFoundPage message={serverData.notFoundMessage} />;
	}

	return (
		<div className="App">
			<ConfigurePage />
		</div>
	);
}

export default App;